// GameHostBridge — standardized event bus between a game and its host.
// Same event names in web (touch/click emit) and kiosk (physical devices).
// See ../CONTRACTS.md §4.

export const PLATFORM_EVENTS = Object.freeze({
  // Hardware / host → game
  BILL_ACCEPTED: 'BILL_ACCEPTED',
  CREDIT_ADDED: 'CREDIT_ADDED',
  SPIN_BUTTON: 'SPIN_BUTTON',
  CASHOUT_REQUEST: 'CASHOUT_REQUEST',
  DEVICE_CONNECTED: 'DEVICE_CONNECTED',
  DEVICE_DISCONNECTED: 'DEVICE_DISCONNECTED',
  DEVICE_ERROR: 'DEVICE_ERROR',

  // Game → host
  GAME_LAUNCH: 'GAME_LAUNCH',
  GAME_READY: 'GAME_READY',
  GAME_SHUTDOWN: 'GAME_SHUTDOWN',
  SPIN_STARTED: 'SPIN_STARTED',
  SPIN_SETTLED: 'SPIN_SETTLED',
  BALANCE_CHANGED: 'BALANCE_CHANGED',
});

export function createEventBus() {
  const listeners = new Map(); // event -> Set<fn>

  return {
    on(event, fn) {
      if (!listeners.has(event)) listeners.set(event, new Set());
      listeners.get(event).add(fn);
      return () => this.off(event, fn);
    },
    off(event, fn) {
      const set = listeners.get(event);
      if (set) set.delete(fn);
    },
    emit(event, payload) {
      const set = listeners.get(event);
      if (!set) return;
      // Copy so a handler can safely unsubscribe during dispatch.
      Array.from(set).forEach((fn) => {
        try { fn(payload); } catch (e) { console.error('[platform-bus]', event, e); }
      });
    },
  };
}
